<template>
    <div id="toppage">
        <div class="top-box">
            <div style="width: 1200px; margin: 0 auto; height: 100%;" class="flx jcsb">
                <div class="flx aic">
                    <img style="width: 121px; height: 47px;" :src="data_list.logo" alt="" class="shouxing" @click="toindex()">
                </div>
                <div class="flx aif" style="height: 75px;">
                    <div style="height: 100%; margin-left: 20px;" class="tc mune-list flx fdc aic jcc" :class="indextap==item.id?'active':''" v-for="(item, index) in mune_list" :key="index" @click="tapindex(item.page)">
                        <i style="font-size: 22px;" :class="item.icon"></i>
                        <div style="font-size: 14px; margin-top: 5px;">{{item.name}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Toppage',
    data () {
        return {
            data_list: '',
            mune_list: [{id: 1, name: '首页', page: '', icon: 'el-icon-house'},
            {id: 2, name: '关于我们', page: 'index2', icon: 'el-icon-user'},
            {id: 3, name: '合作伙伴', page: 'index3', icon: 'el-icon-trophy'},
            {id: 5, name: '最新资讯', page: 'index5', icon: 'el-icon-document'},
            {id: 4, name: '加入我们', page: 'index4', icon: 'el-icon-chat-line-square'},
            ],
            indextap: ''
        }
    },
    methods:{
        tapindex(page) {
            this.$router.push({
                path: '/' + page
            })
        },

        toindex() {
            this.$router.push({
                path: '/'
            })
        },
        sing(id) {
            this.indextap = id;
        },

        getData() {
            this.$post('index.php?s=/api/index/pub_api', {
                wxapp_id: 10001
            })
            .then((res) => {
                if(res.code == 1) {
                    this.data_list = res.data.list;
                }
            }) 
        },
    },
    created() {
        this.getData();
    },
}
</script>

<style>
    .top-box{
        height: 75px;
    }
    .active{
        color: #fff;
        background-color: #C8161D;
    }
    .mune-list{
        min-width: 90px;
        cursor: pointer;
    }
    .mune-list:hover{
        color: #fff;
        background-color: #C8161D;
    }
</style>


// WEBPACK FOOTER //
// src/components/partialset/toppage.vue